import { Helmet } from 'react-helmet'
// import { Link } from "react-router-dom"
// import flyerDecPair from '../../assets/images/slide-decPair.jpg'
// import pdfCookies from '../../CookiesAndCocoa.pdf'

export default function EventList(){
  return (
    <div className="pageStyles eventList">
      <Helmet>
        <title>Delicious Events at Villaggio Grille</title>
        <meta name="description" content="Don't miss these upcoming events and experiences at Villaggio Grille. Your taste buds will thank you!" />
      </Helmet>

      <div className="simpleBanner">
        <div className="sbWrap kpWrapXl">
          <h1>Holiday Season Events &amp; Specials</h1>
          <p className="instr">Select an event from the list below to learn more.</p>
        </div>
      </div>

      <div className="fullSec eventGrid gridSolo">
        <div className="sectionWrap kpWrapXl flexGroup justify-between__XXX justify-center">
          <h2>Check Back Soon for Updates!</h2>
          {/* <div className="item i1 cookies"><a href={pdfCookies} target="_blank" rel="noreferrer"><img src={flyerCookies} alt="Villaggio Christmas Cookie Event" /></a></div>
          <div className="item i2 dpair"><a href={pdfDecPair} target="_blank" rel="noreferrer"><img src={flyerDecPair} alt="December Wine Pairing at Villaggio" /></a></div>
          <div className="item i3 xmas"><a href={pdfXmas} target="_blank" rel="noreferrer"><img src={flyerXmas} alt="Villaggio Christmas menu" /></a></div>
          <div className="item i4 nye"><Link to="/new-years-eve"><img src={flyerNye} alt="Villaggio NYE menus" /></Link></div>
          <div className="clearfix"></div> */}
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
